// extracted by mini-css-extract-plugin
module.exports = {"instantRecsCol":"instantRecsCol--eqhgv","loaderWrapper":"loaderWrapper--eqhgv"};